import { useMutation } from '@tanstack/react-query'
import { confirmTransaction } from '../services'
import { CryptoInvoiceMutationKeys } from '../../keys'

import type { ConfirmTransactionRequest } from '../../type'

export default function useMutationConfirmTransaction() {
	return useMutation({
		mutationKey: [CryptoInvoiceMutationKeys.ConfirmTransaction],
		mutationFn: (payload: ConfirmTransactionRequest) =>
			confirmTransaction(payload),
	})
}
